import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import ReactModal from 'react-modal';
import styles from './codework-modal.css';
import codeworkIcon from './oct-logo.svg';
import { connect } from 'react-redux';
import { setCodeworkAccessToken, setFileServiceRoot,
         newFile, updateFile
        } from './fileslib';
import { setCodeworkFilepath } from '../../reducers/codework-filepath';


const messages = defineMessages({
    title: {
        id: 'gui.saveCodeworkFileModal.title',
        defaultMessage: 'Saving file to Codework',
        description: 'title for the save-codework-file modal'
    }
});

function getFilenameFromProjectTitle(projectTitle) {
  return (projectTitle || 'Untitled Project') + '.sb3';
}

const paramsString = window.location.search;
const params = new URLSearchParams(paramsString);
setCodeworkAccessToken(params.get('u'));
setFileServiceRoot(params.get('fs'));

class CodeworkFileSaveModal extends React.Component {

  constructor(props) {
    super(props);
  }

  handleClose = () => {
    this.props.onClose();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.saveFile();
    }
  }

  // arrayBufferToString = (buf) => {
  //   return String.fromCharCode.apply(null, new Uint8Array(buf));
  // }

  saveFile = () => {
    const pathIfNewFile = '~/' + getFilenameFromProjectTitle(this.props.projectTitle);
    this.props.codeworkFilepath ? null : this.props.onSetCodeworkFilepath(pathIfNewFile);
    const filepath = this.props.codeworkFilepath || pathIfNewFile;
    this.props.saveProjectSb3()
    .then(contentBlob => {
      return contentBlob.arrayBuffer();
    })
    .then(arrayBuffer => {
      // const content = this.arrayBufferToString(arrayBuffer);
      updateFile(filepath, arrayBuffer) //content)
      .then(() => {
        this.handleClose();
      })
      .catch(error => {
        newFile(getFilenameFromProjectTitle(this.props.projectTitle), '~', arrayBuffer, null)
        .then(() => {
          this.handleClose();
        })
        .catch(err => {
          console.error('Error saving file:', err.message || err);
          this.handleClose();
        });
      });
    });
  }

  render() {
    if (!this.props.isOpen) return null;

    return (
      <ReactModal
        isOpen={this.props.isOpen}
        onRequestClose={this.handleClose}
        className={styles.codeworkModalContainer}
        overlayClassName={styles.codeworkModalOverlay}
    >
        <div className={styles.modalHeader}>
          <div className={styles.headerTitle}>
            <img
              className={styles.codeworkIcon}
              src={codeworkIcon}
            />
            <FormattedMessage
              {...messages.title}
            />
          </div>
        </div>
        <div className={styles.modalContent} >
          <p>Saving {this.props.projectTitle}...</p>
        </div>
      </ReactModal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    projectTitle: state.scratchGui.projectTitle,
    codeworkFilepath: state.scratchGui.codeworkFilepath,
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSetCodeworkFilepath: codeworkFilepath => dispatch(setCodeworkFilepath(codeworkFilepath)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CodeworkFileSaveModal);
